import * as utils from './utils';

export function getPackageVersion() {
    return utils.getRunnerVersion();
}
